import { useTokenProvider, useConfig, useLogger, useAuthorizer } from '@gplibraries/react/hooks';
import { useQuery } from '@tanstack/react-query';
import { fetchUserMask } from '@gplibraries/react/api';
/**
 * Fetch dealer mask.
 **
 * @returns {FetchResult}
 */
export function useDealerMask() {
    const logger = useLogger();
    const { dealerAccessApiScope, dealerAccessApiHost } = useConfig();
    const getToken = useTokenProvider({ scopes: [dealerAccessApiScope] });
    // middleware token query
    const { data: token, isLoading: tokenLoading } = useQuery({
        enabled: Boolean(getToken),
        queryKey: ['middlewareToken'],
        queryFn: () => getToken()
    });
    const user = useAuthorizer(token?.accessTokenClaims);
    // Get use the dealer mask as the dealer number if the user is not a dealer, otherwise use their dealer number (gpm Username)
    const { isLoading, isFetching, error, data: mask } = useQuery({
        enabled: Boolean(user) && !user?.isDealer(),
        queryKey: ['userMask', user?.get('id')],
        queryFn: () => getToken()
            .then(token => fetchUserMask(dealerAccessApiHost, token.accessToken, token?.accessTokenClaims?.oid))
            .then(res => res.json()),
        select: (result) => result.data
    });
    if (error)
        logger.error(error, {
            source: 'useDealerMask',
            mask,
        });
    return { data: mask, loading: (isLoading || isFetching || tokenLoading), error };
}
